// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n'; // Import the i18n configuration
import pageSetup from './plugins/setup-page';
import { vI18nHtml } from './directives/i18n-html';
import { datadogLogs } from '@datadog/browser-logs';
import { createHead } from '@unhead/vue';

// Amplify
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import { getVuetify } from './plugins/vuetify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { defaultStorage } from 'aws-amplify/utils';
import gtmPlugin from './plugins/gtmPlugin';
import { initCookieConsent } from './services/consent';

Amplify.configure(awsExports);

// Explicitly configure storage for Cognito tokens and device tracking
// This ensures device keys (deviceKey, deviceGroupKey, randomPasswordKey)
// are properly stored and retrieved in both desktop and WebView environments
cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);

// Vuetify
const vuetify = await getVuetify();

// Creating App
const app = createApp(App);
const head = createHead();

if (gtmPlugin) {
  app.use(gtmPlugin);
}
app.use(head);
app.use(router);
app.use(vuetify);
app.use(i18n);
app.use(pageSetup);
app.directive('i18nHtml', vI18nHtml);

app.config.errorHandler = (err, vm, info) => {
  console.error('error', { err, vm, info });
  datadogLogs.logger.error('error', { err, vm, info });
};

app.mount('#app');

// Consent first, GTM behind it: Google Consent Mode needs the CMP's defaults in
// the dataLayer before the container boots, so `gtmPlugin` no longer loads the
// container itself (see `initCookieConsent`). Deferred until the router has
// settled because the notice language comes from the resolved route — the shared
// Belgian domain serves both `/fr` and `/nl`.
router.isReady().then(initCookieConsent);
